import { LocaleCode } from "./supportedLanguages"

import ar from "../translations/ar.json"
import ar_EG from "../translations/ar-EG.json"
import bg_BG from "../translations/bg-BG.json"
import bn from "../translations/bn.json"
import cs_CZ from "../translations/cs-CZ.json"
import da_DK from "../translations/da-DK.json"
import de from "../translations/de.json"
import el_GR from "../translations/el-GR.json"
import en_US from "../translations/en-US.json"
import es from "../translations/es.json"
import es_MX from "../translations/es-MX.json"
import et_EE from "../translations/et-EE.json"
import fi_FI from "../translations/fi-FI.json"
import fr from "../translations/fr.json"
import ga_IE from "../translations/ga-IE.json"
import ha_NG from "../translations/ha-NG.json"
import he from "../translations/he.json"
import hi from "../translations/hi.json"
import hr_HR from "../translations/hr-HR.json"
import hu from "../translations/hu.json"
import id_ID from "../translations/id-ID.json"
import it from "../translations/it.json"
import ja from "../translations/ja.json"
import ko_KR from "../translations/ko-KR.json"
import lt from "../translations/lt.json"
import lv_LV from "../translations/lv-LV.json"
import ms from "../translations/ms.json"
import mt_MT from "../translations/mt-MT.json"
import nl_NL from "../translations/nl-NL.json"
import pl from "../translations/pl.json"
import pt_BR from "../translations/pt-BR.json"
import ro from "../translations/ro.json"
import ru from "../translations/ru.json"
import sk_SK from "../translations/sk-SK.json"
import sl_SI from "../translations/sl-SI.json"
import sv from "../translations/sv.json"
import sw_KE from "../translations/sw-KE.json"
import ta from "../translations/ta.json"
import th from "../translations/th.json"
import tl from "../translations/tl.json"
import tr_TR from "../translations/tr-TR.json"
import uk_UA from "../translations/uk-UA.json"
import ur_PK from "../translations/ur-PK.json"
import vi from "../translations/vi.json"
import zh_CN from "../translations/zh-CN.json"
import zh_TW from "../translations/zh-TW.json"

const TRANSLATIONS = {
  [LocaleCode.AR]: ar,
  [LocaleCode.AR_EG]: ar_EG,
  [LocaleCode.BG_BG]: bg_BG,
  [LocaleCode.BN]: bn,
  [LocaleCode.CS_CZ]: cs_CZ,
  [LocaleCode.DA_DK]: da_DK,
  [LocaleCode.DE]: de,
  [LocaleCode.EL_GR]: el_GR,
  [LocaleCode.EN_US]: en_US,
  [LocaleCode.ES]: es,
  [LocaleCode.ES_MX]: es_MX,
  [LocaleCode.ET_EE]: et_EE,
  [LocaleCode.FI_FI]: fi_FI,
  [LocaleCode.FR]: fr,
  [LocaleCode.GA_IE]: ga_IE,
  [LocaleCode.HA_NG]: ha_NG,
  [LocaleCode.HE]: he,
  [LocaleCode.HI]: hi,
  [LocaleCode.HR_HR]: hr_HR,
  [LocaleCode.HU]: hu,
  [LocaleCode.ID_ID]: id_ID,
  [LocaleCode.IT]: it,
  [LocaleCode.JA]: ja,
  [LocaleCode.KO_KR]: ko_KR,
  [LocaleCode.LT]: lt,
  [LocaleCode.LV_LV]: lv_LV,
  [LocaleCode.MS]: ms,
  [LocaleCode.MT_MT]: mt_MT,
  [LocaleCode.NL_NL]: nl_NL,
  [LocaleCode.PL]: pl,
  [LocaleCode.PT_BR]: pt_BR,
  [LocaleCode.RO]: ro,
  [LocaleCode.RU]: ru,
  [LocaleCode.SK_SK]: sk_SK,
  [LocaleCode.SL_SI]: sl_SI,
  [LocaleCode.SV]: sv,
  [LocaleCode.SW_KE]: sw_KE,
  [LocaleCode.TA]: ta,
  [LocaleCode.TH]: th,
  [LocaleCode.TR_TR]: tr_TR,
  [LocaleCode.TL]: tl,
  [LocaleCode.UK_UA]: uk_UA,
  [LocaleCode.UR_PK]: ur_PK,
  [LocaleCode.VI]: vi,
  [LocaleCode.ZH_CN]: zh_CN,
  [LocaleCode.ZH_TW]: zh_TW,
}

export const getTranslation = (locale: LocaleCode, key: string): string => {
  if (!locale) return key

  const translations = TRANSLATIONS[locale]
  if (translations && translations[key]) {
    return translations[key]
  }

  // returns the key as a fallback if translation is not found
  return key
}
